import { render, staticRenderFns } from "./SettingsDocuments.vue?vue&type=template&id=67099f6e"
import script from "./SettingsDocuments.vue?vue&type=script&lang=js"
export * from "./SettingsDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports